module.exports = __webpack_public_path__ + "static/media/mex-without-description.46e27509.jpeg";